<template>
  <text
    :style="{
      Color: props.value
        ? 'var(--true-color,#1e90ff)'
        : 'var(--false-color,#f00)',
    }"
  >
    {{ props.value ? "是" : "否" }}
  </text>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  props: {
    value: Boolean,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {});
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
